/**
 * @bref    Fonctionnalitées jQuery relatives au formulaire des Adresses.
 * @remark  Fichier appelé dans un bloc jQuery.
 */
require('../functions/AppAjax.class');
let AppAjax = window.AppAjax;

//#####################################################
// Purge du formulaire modale lors de l'ajout d'une adresse
//#####################################################
$('button.add-address-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-add-address input:not([type=hidden])').each(function() { $(this).val(''); });
    $('form#confirm-add-address select option:selected').each(function() { $(this).prop('selected', false); });
    // Vidage du champ des États/Provinces/Territoires
    AppAjax.clearSelectOptions('form#confirm-add-address select[name=state]');
});

//#####################################################
// Mise à jour des États/Provinces/Territoires au changement de Pays
//#####################################################
$('select[name=country]').on('change', function(event) {
    event.stopPropagation();

    // Récupération du sélecteur du formulaire en cours
    let formId = 'form#' + $(event.target).parents('form:first').attr('id');

    // Récupération du pays sélectionné
    let country_id = $(formId).find('select[name=country] option:selected').val();
    if (country_id) {
        // Mise à jour de la liste des Provinces uniquement dans le formulaire sélectionné
        AppAjax.updateSelectOptions(formId + ' select[name=state]', 'provinces', {
            country_id: country_id
        }, undefined, 'loading');
    } else {
        // Vidage du champ des États/Provinces/Territoires
        AppAjax.clearSelectOptions(formId + ' select[name=state]');
    }
});

//#####################################################
// Send delete address url to the modale form action
//#####################################################
$('button.delete-address-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-delete-address').attr('action', $(this).data('url'));
});
